import React from 'react';
import { formilyReact, Box, Select, CnAsyncSelect, CnInput, CnIcon, CnRadioGroup } from '@alife/cn-ui';
import { CONDITION_OPTIONS, FORMILY_HOOKS } from "../const";
import { FieldsOptionContext } from "../view";
import "./condition-array-form.scss";
var Field = formilyReact.Field,
  ArrayField = formilyReact.ArrayField,
  useField = formilyReact.useField,
  observer = formilyReact.observer;
var ArrayComponent = observer(function () {
  var _field$value;
  var fieldsOption = React.useContext(FieldsOptionContext);
  var field = useField();
  return /*#__PURE__*/React.createElement("div", {
    className: 'conditionFormWrapper'
  }, field === null || field === void 0 ? void 0 : (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", null, index !== 0 && /*#__PURE__*/React.createElement(Field, {
      name: index + ".operator",
      initialValue: 'AND',
      component: [CnRadioGroup, {
        size: 'small',
        placeholder: '选择条件',
        style: {
          'margin': '5px 0 5px 6px'
        },
        dataSource: [{
          label: '与',
          value: 'AND'
        }, {
          label: '或',
          value: 'OR'
        }]
      }]
    }), /*#__PURE__*/React.createElement(Box, {
      direction: 'row',
      spacing: 3,
      className: 'conditionFormBox'
    }, /*#__PURE__*/React.createElement(Box, {
      direction: 'column',
      spacing: 5,
      className: 'leftBox'
    }, /*#__PURE__*/React.createElement(Box, {
      direction: 'row'
    }, /*#__PURE__*/React.createElement(Field, {
      name: index + ".effects",
      initialValue: 'onFieldValueChange',
      component: [CnAsyncSelect, {
        placeholder: '选择触发时机',
        style: {
          flex: 1
        },
        dataSource: FORMILY_HOOKS
      }]
    }), /*#__PURE__*/React.createElement(Field, {
      name: index + ".watchCode",
      component: [CnAsyncSelect.AutoComplete, {
        placeholder: '选择字段',
        style: {
          flex: 1
        },
        dataSource: fieldsOption
      }]
    })), /*#__PURE__*/React.createElement(Box, {
      direction: 'row'
    }, /*#__PURE__*/React.createElement(Field, {
      name: index + ".condition",
      component: [CnAsyncSelect, {
        placeholder: '选择条件',
        style: {
          flex: 1
        },
        dataSource: CONDITION_OPTIONS
      }]
    }), /*#__PURE__*/React.createElement(Field, {
      name: index + ".conditionValue",
      component: [CnInput, {
        placeholder: '输入值',
        style: {
          flex: 1
        }
      }]
    }))), /*#__PURE__*/React.createElement(Box, {
      direction: 'column',
      justify: 'center',
      className: 'rightBox'
    }, /*#__PURE__*/React.createElement(CnIcon, {
      style: {
        cursor: 'pointer',
        color: '#284cc0',
        height: '32px'
      },
      type: "add-r",
      size: 'large',
      onClick: function onClick() {
        field.insert(index + 1, {});
      }
    }), field.value.length > 1 && /*#__PURE__*/React.createElement(CnIcon, {
      type: "minus-r",
      size: 'large',
      style: {
        cursor: 'pointer',
        color: '#e55346',
        height: '32px'
      },
      onClick: function onClick() {
        field.remove(index);
      }
    }))));
  }));
});
export default (function (_ref) {
  var name = _ref.name;
  if (!Box || !Select) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ArrayField, {
    name: name,
    component: [ArrayComponent],
    initialValue: [{}]
  });
});